type SwCacheAction =
  | { type: 'CLIENT_SWITCH'; clientId: string; prewarm?: boolean }
  | { type: 'CLEAR_DATA_CACHE'; prewarm?: boolean }

const postToSw = async (message: SwCacheAction) => {
  if (!('serviceWorker' in navigator)) return false

  // Ensure SW is ready
  await navigator.serviceWorker.ready

  // Prefer controller; fallback to active registration worker if needed
  const controller = navigator.serviceWorker.controller
  if (controller) {
    controller.postMessage(message)
    return true
  }

  // Rare edge case: ready resolved but controller still null
  const reg = await navigator.serviceWorker.getRegistration()
  if (reg?.active) {
    reg.active.postMessage(message)
    return true
  }

  console.warn('No active service worker controller/active worker found')
  return false
}

/**
 * Clears BOTH cache groups (core + data) in SW.
 * Call this when client/tenant changes.
 */
export const resetServiceWorkerCacheOnClientSwitch = async (
  clientId: string,
  opts?: { prewarm?: boolean }
) => {
  return postToSw({
    type: 'CLIENT_SWITCH',
    clientId,
    prewarm: opts?.prewarm ?? false,
  })
}

/**
 * Clears ONLY the "data" cache group in SW (on-demand).
 * Call this when you want to invalidate data endpoints without changing client.
 */
export const resetServiceWorkerDataCache = async (opts?: {
  prewarm?: boolean
}) => {
  return postToSw({
    type: 'CLEAR_DATA_CACHE',
    prewarm: opts?.prewarm ?? false,
  })
}
